import { Map } from 'immutable';
import actions from 'redux/constants/admin/doctors';

const defaultState = () => new Map({
  doctorsList: new Map(),
  doctorsAreLoading: true,

  doctorItem: new Map(),
  doctorIsSubmitting: false,
  doctorCreateFailed: false,
  doctorUpdateFailed: false,

  doctorDetail: new Map(),
  doctorDetailIsLoading: true,

  professionsList: new Map(),
  professionsAreLoading: true,

  photo: undefined
})

export default (state = defaultState(), action) => {
  switch(action.type) {
    case actions.LOAD_DOCTORS:
      return state.set('doctorsList', action.data);
    case actions.DOCTORS_ARE_LOADING:
      return state.set('doctorsAreLoading', action.data);

    case actions.SET_DOCTOR_ITEM:
      return state.set('doctorItem', action.data);

    case actions.LOAD_DOCTOR_DETAIL:
      return state.set('doctorDetail', action.data);
    case actions.DOCTOR_DETAIL_IS_LOADING:
      return state.set('doctorDetailIsLoading', action.data);
  
    case actions.SET_DOCTOR_ITEM_VALUE:
      return state.setIn(['doctorItem', ...action.key], action.data);
    case actions.DOCTOR_IS_SUBMITTING:
      return state.set('doctorIsSubmitting', action.data);
    case actions.DOCTOR_CREATE_FAILED:
      return state.set('doctorCreateFailed', action.data);
    case actions.DOCTOR_UPDATE_FAILED:
      return state.set('doctorUpdateFailed', action.data);
    
    case actions.LOAD_PROFESSIONS:
      return state.set('professionsList', action.data);
    case actions.PROFESSIONS_ARE_LOADING:
      return state.set('professionsAreLoading', action.data);
    

        default:
      return state;
  }
}


// WEBPACK FOOTER //
// ./src/redux/reducers/admin/doctors.js